
































import {
	computed,
	defineComponent,
	onUnmounted,
	PropType,
	ref,
	watch,
} from '@vue/composition-api';
import EditorMenu from '@front-app/components/form/tiptap/EditorMenu.vue';
import EditorContent from '@front-app/components/form/tiptap/EditorContent.vue';
import EditorContainer from '@front-app/components/form/tiptap/EditorContainer.vue';
import { useTiptapEditor } from '@front-app/components/form/tiptap/useTiptapEditor';
import FormSection from '@front-app/components/form/FormSection.vue';
import { useHighlightsInput } from '../../hooks/useHighlightsInput';
import { HighlightsRichTextComponent } from '../../model';
import BaseEditor from '../BaseEditor.vue';

export default defineComponent({
	components: {
		EditorMenu,
		EditorContent,
		EditorContainer,
		BaseEditor,
		FormSection,
	},
	props: {
		value: {
			type: Object as PropType<HighlightsRichTextComponent>,
			required: true,
		},
	},
	setup(props, ctx) {
		const id = computed(() => props.value.id || props.value.id);
		const useInput = useHighlightsInput(ctx, computed(() => props.value));
		const el = ref(null as null | Element);
		const { editor } = useTiptapEditor(el);

		watch(id, (curr, prev) => {
			if (curr === prev) {
				return;
			}
			editor.chain().setContent(props.value.meta.mainText).run();
		}, { immediate: true });

		const onUpdate = () => {
			useInput.doMetaInput({ mainText: editor.getHTML() });
		};

		editor.on('update', onUpdate);
		onUnmounted(() => {
			editor.off('update', onUpdate);
		});

		return {
			el,
			editor,
		};
	},
});
